"use client";

import CoreTechDesktop from "@/components/ui/core-it-block/CoreTechDesktop";
import CoreTechMobile from "@/components/ui/core-it-block/CoreTechMobile";
import { useDeviceType } from "@/hooks/useDeviceType";
import type { CoreTechProps } from "./types";

export default function CoreTechBlock({ items }: CoreTechProps) {
    const deviceType = useDeviceType();
    const isMobile = deviceType === "phone" || deviceType === "tablet";

    if (!items?.length) return null;

    const Component = isMobile ? CoreTechMobile : CoreTechDesktop;

    return (
        <div className="w-full max-w-[1920px] mx-auto px-5 mt-10 xl:mt-0  lg:px-30 xl:px-50">
            <Component items={items} />
        </div>
    );
}
